/* ============================================================
   MAZ theme · interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var burger = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-mobile]');
    var scrim = document.querySelector('[data-scrim]');
    if (!burger || !menu) return;
    function open() { menu.classList.add('open'); if (scrim) scrim.classList.add('open'); }
    function close() { menu.classList.remove('open'); if (scrim) scrim.classList.remove('open'); }
    burger.addEventListener('click', open);
    if (scrim) scrim.addEventListener('click', close);
    menu.querySelectorAll('[data-close], a').forEach(function (el) {
      el.addEventListener('click', close);
    });
  }

  /* ---------- Product detail gallery ---------- */
  function initPdpGallery() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(function (g) {
      var main = g.querySelector('[data-pdp-main]');
      g.querySelectorAll('[data-pdp-thumb]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-full');
          if (src && main) main.setAttribute('src', src);
          g.querySelectorAll('[data-pdp-thumb]').forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Projects showcase carousel ---------- */
  function initShowcase() {
    document.querySelectorAll('[data-showcase]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var catBtns = Array.prototype.slice.call(root.querySelectorAll('[data-cat-btn]'));
      var counter = root.querySelector('[data-counter]');
      var cat = 'All';
      var idx = 0;

      function visible() {
        return slides.filter(function (s) {
          return cat === 'All' || s.getAttribute('data-cat') === cat;
        });
      }
      function render() {
        var list = visible();
        if (!list.length) list = slides;
        if (idx > list.length - 1) idx = 0;
        if (idx < 0) idx = list.length - 1;
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        list[idx].classList.add('is-active');
        if (counter) counter.textContent = 'Project ' + (idx + 1) + ' of ' + list.length;
        catBtns.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-cat-btn') === cat);
        });
      }
      function step(d) { idx += d; render(); }

      root.querySelectorAll('[data-next]').forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
      root.querySelectorAll('[data-prev]').forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
      catBtns.forEach(function (b) {
        b.addEventListener('click', function () { cat = b.getAttribute('data-cat-btn'); idx = 0; render(); });
      });

      /* thumbnails inside each slide swap that slide's main image */
      slides.forEach(function (s) {
        var main = s.querySelector('[data-slide-main]');
        s.querySelectorAll('[data-slide-thumb]').forEach(function (t) {
          t.addEventListener('click', function () {
            var src = t.getAttribute('data-src');
            if (src && main) main.setAttribute('src', src);
            s.querySelectorAll('[data-slide-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
            t.classList.add('is-active');
          });
        });
      });

      /* basic swipe */
      var sx = null;
      var stage = root.querySelector('[data-stage]');
      if (stage) {
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
          sx = null;
        }, { passive: true });
      }

      render();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initPdpGallery();
    initShowcase();
  });
})();
